import { UserMenuListResponseModel } from './userMenuList.model';

export type UserMenuListState = UserMenuListResponseModel[];

export const initialUserMenuListState: UserMenuListState = [];
